import { useGustoMemberIdMigrationEffect } from 'containers/payroll/gusto/hooks/useGustoMemberIdMigration/useGustoMemberIdMigration';
import useGustoCompanyId from 'components/domain/integration/gusto/hooks/company/useGustoCompanyId/useGustoCompanyId';
import useGustoGetCompany from 'components/domain/integration/gusto/hooks/company/useGustoGetCompany/useGustoGetCompany';
import useGustoGetMe from 'components/domain/integration/gusto/hooks/me/useGustoGetMe/useGustoGetMe';
import useGustoUpdateTermsOfService from 'components/domain/integration/gusto/hooks/terms-of-service/useGustoUpdateTermsOfService/useGustoUpdateTermsOfService';
import { useReduxSelector } from 'hooks';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setGustoCompany, setGustoMe } from 'store/gusto/gusto';
import { IChildrenProps } from 'types/ChildrenProps';

export default function GustoMiddleware({ children }: IChildrenProps) {
  const getCompany = useGustoGetCompany();
  const getMe = useGustoGetMe();
  const gustoCompanyId = useGustoCompanyId();
  const { me } = useReduxSelector((state) => state.gusto);
  const dispatch = useDispatch();
  const email = me?.email;
  const updateTos = useGustoUpdateTermsOfService();

  useEffect(() => {
    if (gustoCompanyId) {
      getCompany(gustoCompanyId)
        .then((company) => {
          dispatch(setGustoCompany(company));
        })
        .catch(() => {
          // Catching because of desynced getCompany/gustoCompanyId can cause a 404.
        });
    }
  }, [dispatch, getCompany, gustoCompanyId]);

  useEffect(() => {
    getMe()
      .then((me) => {
        dispatch(setGustoMe(me));
      })
      .catch(() => {
        // need to make request to see if they have a `/me` but they won't necessarily have a company id to validate
      });
  }, [dispatch, getMe]);

  useEffect(() => {
    updateTos();
  }, [gustoCompanyId, email, updateTos]);

  useGustoMemberIdMigrationEffect();

  return <>{children}</>;
}
